/**
 * Generated by '@kontent-ai/model-generator@6.5.1' at 'Thu, 01 May 2025 19:26:26 GMT'
 *
 * Project name: Benefits Counselor
 * Environment: Production
 * Environment Id: 831b591e-b12f-007a-2617-a35180c56dda
 */
export const languages = {
    /**
     * Default project language
     */
    default: {
        codename: 'default',
        id: '00000000-0000-0000-0000-000000000000',
        isActive: true,
        isDefault: true,
        fallbackLanguageId: '00000000-0000-0000-0000-000000000000',
        externalId: undefined,
        name: 'Default project language'
    }
};
//# sourceMappingURL=languages.js.map